"use client";

import { isValidElement } from "react";
import { Toaster, ToastBar, resolveValue, Toast } from "react-hot-toast";
import { t } from "@/lib/localization";

interface ExtendedToast extends Toast {
    keyName?: string;
}

export default function ToastProvider() {
    return (
        <Toaster>
            {(toast: Toast) => {
                const extendedToast = toast as ExtendedToast;
                const message = resolveValue(toast.message, toast);

                const keyName = extendedToast.keyName;

                return (
                    <ToastBar toast={toast}>
                        {({ icon }) => (
                            <div className="flex items-center gap-3 py-1 px-2">
                                {icon}
                                {keyName
                                    ? t(keyName, undefined, undefined)
                                    : isValidElement(message)
                                      ? message
                                      : String(message)}
                            </div>
                        )}
                    </ToastBar>
                );
            }}
        </Toaster>
    );
}
